import { useEffect, useState } from "react";
import SideBar from "../../../components/SideBar";
import Main from "../Main";

import {
  useNavigate,
  useLoaderData,
  useLocation,
  redirect,
} from "react-router-dom";
import { axios } from "../../../Global";
import { useDispatch, useSelector } from "react-redux";
import { setPage } from "../../../store/userSlice";
import { getDashbaordData } from "../../../store/Api";
import nodeinstance from "../../../nodeInstance";
import LoadingWithLable from "../../../ReusableComponents/Loading/LoadingWithLable";

const upperCaseWords = (str) =>
  str.replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase());

export default function Dashboard() {
  let token = localStorage.getItem("token");

  let NodeToken = localStorage.getItem("nodeToken");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [navbarOpen, setNavbarOpen] = useState(false);
  const dashboardData = useSelector((state) => state.dashboardData);

  const loaderData = useLoaderData();



  useEffect(() => {
    if (location.pathname !== "/dashboard") {
      const currentPage = upperCaseWords(
        String(location.pathname.split("/")[2].split("-").join(" "))
      );
      // if(location?.pathname?.split("/")?.length===4){
      //   const currentPage2 = upperCaseWords(
      //     String(location.pathname.split("/")[3]?.split("-")?.join(" "))
      //   );
      //   if (currentPage && currentPage2 !== "") {
      //     dispatch(setPage(`${currentPage}/${currentPage2}`));
      //   }
      // }
      // else{
        if (currentPage !== "") {
          dispatch(setPage(currentPage));
        }
      // }
    } else {
      dispatch(setPage("Dashboard"));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!dashboardData.data) {
      if (NodeToken) {
        dispatch(getDashbaordData(NodeToken));
      } else {
        navigate("/");
      }
    }     
  }, []);

  const { dashboardPage } = useSelector((state) => state.user);
  // console.log(dashboardPage);

  // useEffect(() => {
  //   if (loaderData?.status === 200) {
  //     navigate("/dashboard");
  //   } else {
  //     navigate("/login");
  //   }
  // }, []);

  return (
    <>
      {dashboardData.status === true ? (
        <div className="flex w-full relative">
          <SideBar navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} />
          <div
            className={`w-full ${
              navbarOpen && " h-96 overflow-y-hidden sm:h-auto sm:overflow-auto"
            }`}
          >
            <Main navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} />
          </div>
        </div>
      ) : dashboardData.error ? (
        <div className="flex flex-col items-center justify-center h-screen gap-4">
          <p className="text-red-500 text-lg font-semibold">{dashboardData.error}</p>
          <button 
            className="p-2 px-4 bg-blue text-white rounded-md hover:bg-blue/90"
            onClick={() => dispatch(getDashbaordData(NodeToken))}
          >
            Retry
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-center h-screen">
           <LoadingWithLable />
        </div>
      )}
    </>
  );
}

export async function loader() {
  const token = localStorage.getItem("token");
  const NewToken = localStorage.getItem("nodeToken")
  if (token) {
    try {
      const result = await nodeinstance.get("/dashboard/data", {
        headers: { Authorization: `Bearer ${NewToken}` },
      });
      return result;
    } catch (e) {
      localStorage.removeItem("token");
      localStorage.removeItem("nodeToken");
      const message = e.response.data.message;
      if (message == "Unauthenticated.") {
        redirect("/login");
      }
    }
  } else {
    redirect("/login");
    throw new Response("Not Authenticated", { status: 401 });
  }
}
